<template>
  <footer
    class="flex justify-center w-full bg-coal"
    :class="isRoute === '/yp/register' ? 'hidden' : ''"
  >
    <div class="w-full xl:w-5/6 max-xl:px-3 py-5 md:py-10 text-white">
      <div
        class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 w-full mb-5 md:mb-10 gap-5 md:gap-10"
      >
        <div>
          <h1 class="text-gold text-2xl font-bold uppercase">
            {{ lang === "mn" ? "ЛОГО" : "LOGO" }}
          </h1>
          <h6 class="text-grey text-xs">
            {{
              lang === "mn"
                ? "Монголын уул уурхайн нэгдсэн лавлах"
                : "Mongolian mining directory"
            }}
          </h6>
        </div>

        <ul class="text-sm">
          <li class="font-bold text-lg uppercase mb-3">
            {{ lang === "mn" ? "Лавлах" : "Directory" }}
          </li>
          <li class="hover:underline mb-1.5">
            <router-link to="/yp/register">
              {{ lang === "mn" ? "Мэдээлэл нэмэх" : "Contribute Information" }}
            </router-link>
          </li>
          <li class="hover:underline mb-1.5">{{ lang === "mn" ? "" : "" }}</li>
          <li class="hover:underline">{{ lang === "mn" ? "" : "" }}</li>
        </ul>

        <!-- <ul class="text-sm">
          <li class="font-bold text-lg uppercase mb-3">
            {{ lang === "mn" ? "Тусламж" : "Help" }}
          </li>
          <li class="hover:underline mb-1.5">
            {{ lang === "mn" ? "Үйлчилгээний нөхцөл" : "Terms & conditions" }}
          </li>
          <li class="hover:underline">
            {{
              lang === "mn"
                ? "Түгээмэл асуулт & хариулт"
                : "Frequently Asked Questions"
            }}
          </li>
        </ul> -->

        <ul class="text-sm">
          <li class="font-bold text-lg uppercase mb-3">
            {{ lang === "mn" ? "Холбоо барих" : "Contact" }}
          </li>
          <li class="flex items-center gap-3 mb-1.5">
            <font-awesome-icon icon="fa-solid fa-phone" class="text-gold" />
            (+976) 70110163
          </li>
          <li class="flex items-center gap-3 mb-1.5">
            <font-awesome-icon
              icon="fa-solid fa-envelope-open-text"
              class="text-gold"
            />
            info@miningguide.mn
          </li>
          <li class="flex items-start gap-3">
            <font-awesome-icon icon="fa-solid fa-map-pin" class="text-gold" />
            {{
              lang === "mn"
                ? "Монгол Улс, Улаанбаатар хот, СБД, 1-р хороо, Элчингийн гудамж, Скай плаза бизнес төв, Д корпус 2 давхар"
                : "2nd floor, D section, 'Sky Plaza' Business Center, Embassy Rd, Sukhbaatar district, Ulaanbaatar, Mongolia 14220"
            }}
          </li>
        </ul>
      </div>

      <div
        class="flex justify-between w-full py-5 border-t border-b border-gray-300 text-xl"
      >
        <div class="flex gap-5">
          <a
            href="https://www.facebook.com/miningmongolia"
            class="hover:text-gold"
          >
            <font-awesome-icon icon="fa-brands fa-facebook" />
          </a>
          <a href="https://x.com/miningmongolia" class="hover:text-gold">
            <font-awesome-icon icon="fa-brands fa-x-twitter" />
          </a>
          <a
            href="https://www.instagram.com/mongolian_mining_association/"
            class="hover:text-gold"
            ><font-awesome-icon icon="fa-brands fa-instagram"
          /></a>
          <a
            href="https://www.youtube.com/@miningmongolia"
            class="hover:text-gold"
          >
            <font-awesome-icon icon="fa-brands fa-youtube" />
          </a>
        </div>
      </div>

      <div class="flex max-sm:flex-col sm:justify-between max-sm:gap-1 mt-5">
        <div class="flex max-sm:flex-col sm:items-center gap-1 sm:gap-3">
          <router-link to="/yp" class="font-bold text-sm">
            miningguide.mn
          </router-link>
          <p class="font-light text-xs">
            &copy; 2025
            {{
              lang === "mn"
                ? "Зохиогчийн эрх хамгаалагдсан."
                : "All rights reserved."
            }}
          </p>
        </div>

        <a href="https://bowsys.mn" class="font-light text-xs"
          >Powered by <span class="font-bold text-sm">BOW LLC</span></a
        >
      </div>
    </div>
  </footer>
</template>

<script>
import { computed, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

export default {
  name: "YPFooter",
  setup() {
    const store = useStore();
    const lang = computed(() => store.getters.getLanguage);

    const route = useRoute();
    const isRoute = ref(route.path);

    watch(
      () => route.path,
      (newPath) => {
        isRoute.value = newPath;
      }
    );

    return { lang, isRoute };
  },
};
</script>
